import React, { useState, useEffect } from 'react'

import { connect } from 'react-redux'
import "./feeback.css"

import { endGame, gameStart, overView, playAudio, setGameIntroSteps, setLogin, setShowDiceBtn, setStep } from '../../reduxStore/actions/action'
import { Button } from 'antd'


function ThanksPage({ endGame, utilAssets, gameStart, overView, setGameIntroSteps, setStep, setShowDiceBtn, setLogin, playAudio }) {

    useEffect(() => {
        endGame(() => {

        }, () => {

        })
    }, [])

    const handleGameStart = () => {
        overView(() => {
            gameStart(() => {
                setStep(1);
                setShowDiceBtn(false);
                setGameIntroSteps(0);
            }, () => {
                console.log('unable to start game')
            })

        }, () => { })

    }
    return (
        <div className="r-c-c" style={{ width: "100%", height: "100dvh" }}>
            <div className='r-c-c' style={{ width: "50%", height: "100%" }} ><img src={utilAssets?.modalBg} className='full-img' /></div>
            <div className='r-c-c-c' style={{ position: "absolute" }}>
                <div style={{ fontSize: 45, fontWeight: "bolder", width: "70%", textAlign: "center" }} >Thank you for playing SeTU</div>
                {/* <div className='m-t-10' style={{ fontSize: 25, fontWeight: 'bolder' }}>Do play again!</div> */}
                <div className='r-c-c m-t-20 play-btn'>
                    {/* <Button onClick={handleGameStart} style={{ minWidth: "15%", minHeight: "5vh", marginRight: 10, borderRadius: 12 }} >Play again</Button> */}
                    <Button onClick={() => {
                        setLogin();
                        const audio = document.getElementById("audio-tag");
                        audio.pause();
                    }} style={{ minWidth: "15%", minHeight: "5vh", borderRadius: 12 }}>Exit</Button>
                </div>
            </div>
        </div>
    )
}

const mapStateToProps = state => {

    const { utilAssets } = state?.SeTu;
    return { utilAssets }
}


const mapDispatchToProps = dispatch => ({
    endGame: (successCallback, callBack) => dispatch(endGame(successCallback, callBack)),
    overView: (successCallBack, callBack) => dispatch(overView(successCallBack, callBack)),
    gameStart: (successCallBack, callBack) => dispatch(gameStart(successCallBack, callBack)),
    setGameIntroSteps: (val) => dispatch(setGameIntroSteps(val)),
    setStep: (val) => dispatch(setStep(val)),
    setShowDiceBtn: (val) => dispatch(setShowDiceBtn(val)),
    setLogin: (val) => dispatch(setLogin(val)),
    playAudio: (val) => dispatch(playAudio(val))
})

export default connect(mapStateToProps, mapDispatchToProps)(ThanksPage)
